import { EProductsId } from '@r1-frontend/shared/types/EProductsId';

import { IMinPrice } from '~/src/entities/tariff-lines';

export const getProductIDsByMinPrices = (minPrices: IMinPrice[] = [], isVillage: boolean): EProductsId[] => {
    const price = minPrices.find(item => item.is_cottage === Number(isVillage));

    if (price?.is_bundle === 1) {
        return [EProductsId.internet, EProductsId.tv];
    }

    return [EProductsId.internet];
};
